import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { SITE } from "@/lib/site";

export default function Hero() {
    return (
        <section
            data-testid="hero-section"
            className="relative min-h-[100vh] w-full flex items-end overflow-hidden"
        >
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                    backgroundImage:
                        "url(https://images.unsplash.com/photo-1647286380953-1758b08834c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxhaXJwbGFuZSUyMGZseWluZyUyMHN1bnNldCUyMHNreXxlbnwwfHx8fDE3NzY0MTEyMDZ8MA&ixlib=rb-4.1.0&q=85)",
                }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-navy/70 via-navy/40 to-navy" />
            <div className="absolute inset-0 bg-gradient-to-r from-navy/80 via-navy/20 to-transparent" />

            <div className="relative z-10 w-full max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 pb-24 pt-40">
                <div className="max-w-3xl">
                    <motion.p
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="overline"
                        data-testid="hero-eyebrow"
                    >
                        Midasis Flyaway · Est. Hyderabad
                    </motion.p>

                    <motion.h1
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.1 }}
                        className="font-serif text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.05] mt-6 tracking-tight"
                        data-testid="hero-title"
                    >
                        Where every journey <br />
                        becomes a <em className="italic text-gold">story.</em>
                    </motion.h1>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.25 }}
                        className="font-sans text-base sm:text-lg text-white/70 mt-8 max-w-xl leading-relaxed"
                        data-testid="hero-subtitle"
                    >
                        {SITE.tagline} — curated escapes, private guides and unhurried itineraries
                        for travelers who want to feel something, not just see it.
                    </motion.p>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.9, delay: 0.4 }}
                        className="mt-10 flex flex-wrap items-center gap-4"
                    >
                        <Link
                            to="/packages"
                            data-testid="hero-cta-explore"
                            className="group inline-flex items-center gap-3 bg-gold text-navy hover:bg-[#E5C158] px-8 py-4 font-sans font-medium uppercase tracking-wider text-xs transition-all duration-300"
                        >
                            Explore Packages
                            <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
                        </Link>
                        <Link
                            to="/destinations"
                            data-testid="hero-cta-destinations"
                            className="inline-flex items-center gap-3 border border-gold/70 text-gold hover:bg-gold/10 px-8 py-4 font-sans font-medium uppercase tracking-wider text-xs transition-all duration-300"
                        >
                            Discover Destinations
                        </Link>
                    </motion.div>
                </div>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.8 }}
                    className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-12 border-t border-white/10 pt-10"
                >
                    {[
                        { k: "12+", v: "Years curating travel" },
                        { k: "60+", v: "Destinations worldwide" },
                        { k: "4,800+", v: "Happy travelers" },
                        { k: "24/7", v: "Concierge support" },
                    ].map((s) => (
                        <div key={s.v}>
                            <p className="font-serif text-4xl text-gold">{s.k}</p>
                            <p className="font-sans text-xs uppercase tracking-widest text-white/55 mt-2">{s.v}</p>
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
